<template>
  <v-card outlined>
    <v-card-title>{{ `${$t('sod.ttl.ra.auth')} ${$t('common.define')}` }}</v-card-title>
    <v-card-text class="pa-2 pt-0">
      <v-row v-show="raItem.riskType == 'P'">
        <!-- eslint-disable-next-line prettier/prettier -->
        <v-col cols="2"><p class="label">{{ $t('sod.ttl.prfl') }}</p></v-col>
        <v-col cols="10">
          <!-- eslint-disable-next-line prettier/prettier -->
          <v-autocomplete
            v-model="item.authObj" :items="prflList" :label="$t('sod.ph.prfl')"
            clearable dense flat hide-no-data solo hide-details
            @update:search-input="searchProfile"
          />
        </v-col>
      </v-row>
      <v-row v-show="raItem.riskType == 'A'">
        <!-- eslint-disable-next-line prettier/prettier -->
        <v-col cols="2"><p class="label">{{ $t('sod.ttl.auth.obj') }}</p></v-col>
        <v-col cols="4">
          <!-- eslint-disable-next-line prettier/prettier -->
          <v-autocomplete
            v-model="item.authObj" :items="objList" :label="$t('sod.ph.auth.obj')"
            clearable dense flat hide-no-data solo hide-details
            @update:search-input="searchAuthObj"
          />
        </v-col>
        <!-- eslint-disable-next-line prettier/prettier -->
        <v-col cols="1"><p class="label">{{ $t('sod.ttl.auth.fld') }}</p></v-col>
        <v-col cols="2">
          <!-- eslint-disable-next-line prettier/prettier -->
          <v-text-field
            v-model="item.authFld" outlined dense hide-details style="text-transform: uppercase"
            @input="item.authFld = item.authFld.toUpperCase()"
          />
        </v-col>
        <!-- eslint-disable-next-line prettier/prettier -->
        <v-col cols="1"><p class="label">{{ $t('sod.ttl.auth.val') }}</p></v-col>
        <v-col cols="2">
          <!-- eslint-disable-next-line prettier/prettier -->
          <v-text-field
            v-model="item.authVal" outlined dense hide-details style="text-transform: uppercase"
            @input="item.authVal = item.authVal.toUpperCase()"
          />
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn class="mr-2" :disabled="!isSavable" small color="primary" @click="saveRaAuth">{{ $t('common.save') }}</v-btn>
      <v-btn class="mr-2" small color="primary" @click="cancelRaAuth">{{ $t('common.cancel') }}</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { isEmpty } from 'lodash';

import { api } from '@/api/common/instances';
// import { SOD_RISK_TYPE } from '@/constants';

export default {
  props: {
    authId: {
      type: Number,
    },
    raId: {
      type: Number,
    },
  },
  data() {
    return {
      item: {
        raId: 0,
        authObj: '',
        authFld: '',
        authVal: '',
      },
      raItem: {},
      /* auto-complete */
      objList: [],
      prflList: [],
    };
  },
  computed: {
    systemId() {
      return this.$route.params.systemId;
    },
    isSavable() {
      const isPrflSavable = this.raItem.riskType == 'P' && !isEmpty(this.item.authObj);
      const isAuthSavable = this.raItem.riskType == 'A' && !isEmpty(this.item.authObj) && !isEmpty(this.item.authFld) && !isEmpty(this.item.authVal);
      return isPrflSavable || isAuthSavable;
    },
  },
  watch: {
    authId: {
      handler(val) {
        if (val == 0) this.item = {};
        else this.fetchRaAuth();
      },
    },
    raId: {
      handler(val) {
        if (val == 0) this.raItem = {};
        else this.fetchRa();
      },
    },
  },
  methods: {
    async searchAuthObj(input) {
      // v-autocomplete 컴포넌트가 created() 되면 초기값이 null이어서 list가 빈 array이어서 무한루프가 발생한다.
      // 또한, 값이 변하지 않은 상태이면 list를 조회하러 갈 필요없다.
      if (input === null || input == this.item.authObj) return;
      const params = { sstmId: this.systemId, authObj: input.toUpperCase() };
      const { data: items } = await api.get('/sod/auto-search/auth-object', { params });
      this.objList = items;
    },
    async searchProfile(input) {
      if (input === null || input == this.item.authObj) return;
      const params = { sstmId: this.systemId, profn: input.toUpperCase() };
      const { data: items } = await api.get('/sod/auto-search/profile', { params });
      this.prflList = items;
    },
    async saveRaAuth() {
      if (await this.$dialog.confirm(this.$t('common.save.q'))) {
        this.item.raId = this.raId;
        this.item.riskType = this.raItem.riskType;
        const { status } = await api.post('/sod/ra-auth', this.item);
        if (status === 200) {
          this.$snackbar(this.$t('common.successful'));
          this.$emit('close', 'save');
          this.item = {};
        }
      }
    },
    cancelRaAuth() {
      this.$emit('close', 'cancel');
      this.item = {};
    },
    /**
     * this.item.authObj를 objList에 push하는 이유는 다음과 같다.
     * - authObj를 표현하는 필드는 <v-autocomplete>로 되어 있는데,
     *   'add'가 아니라 'edit'로 동작할 때 현재 데이터 값을 보여주려면
     *   objList에 현재 데이터 값이 들어 있어야 한다.
     */
    async fetchRaAuth() {
      const params = { authId: this.authId };
      const { data: item } = await api.get('/sod/ra-auth', { params });
      this.item = item;
      if (this.raItem.riskType == 'P') this.prflList.push(this.item.authObj);
      if (this.raItem.riskType == 'A') this.objList.push(this.item.authObj);
    },
    async fetchRa() {
      const params = { raId: this.raId };
      const { data: item } = await api.get('/sod/ra', { params });
      this.raItem = item;
    },
  },
};
</script>

<style scoped>
.label {
  text-align: right;
  padding: 4px 15px 0px 0px;
}
.v-text-field {
  width: 100%;
}
</style>
